import * as React from 'react';

import { TruncateWord } from './TruncateWord';

export interface EmailProps {
  email: string | undefined;
  truncate?: boolean;
}
export const Email: React.SFC<EmailProps> = (props: EmailProps) => {
  if (!props.email) {
    return <span>None</span>;
  }
  return (
    <a href={'mailto:' + props.email}>
      {props.truncate ? <TruncateWord text={props.email} limit={20} /> : props.email}
    </a>
  );
};



// WEBPACK FOOTER //
// ./src/common/components/Email.tsx